import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import Vue from 'vue';

Bugsnag.start({
    apiKey: process.env.VUE_APP_BUGSNAG_KEY,
    plugins: [new BugsnagPluginVue()],
    releaseStage: process.env.VUE_APP_ENV,
});

const bugsnagVue = Bugsnag.getPlugin('vue');

if (bugsnagVue) {
    bugsnagVue.installVueErrorHandler(Vue);
}

export function setBugsnagUser(authUser) {
    if (authUser && authUser.sub) {
        Bugsnag.setUser(authUser.sub, authUser.email, authUser.name || undefined);
        Bugsnag.addMetadata('auth0', {
            email: authUser.email,
            name: authUser.name,
            ...authUser,
        });
    }
}

export default Bugsnag;
